import { axiosWithoutToken } from "@/utils/axios";
import type { ApiResponse } from "@/types";
import type {
  AdminLoginCommand,
  AdminLoginResponse,
  AdminMFACommand,
  AdminMFAAuthenticateResponse,
  ResendMFACommand,
  ResendMFAResponse,
} from "@/types/admin";
import type { AxiosResponse } from "axios";
import type { TAppUser } from "@/types";

class AuthenticationService {
  register(payload: { first_name: string; last_name: string; email: string }) {
    return axiosWithoutToken.post("/auth/start_signup", payload);
  }

  verifyUser(payload: { otp_code: string; email: string }) {
    return axiosWithoutToken.post("/auth/verify_user", payload);
  }

  resendOTP(payload: { email: string }) {
    return axiosWithoutToken.post("/auth/resend_otp", payload);
  }

  forgotPassword(payload: { email: string }) {
    return axiosWithoutToken.patch("/auth/forget_password", payload);
  }

  verifyResetOTP(payload: { email: string; otp_code: string }) {
    return axiosWithoutToken.post("/auth/verify_otp", payload);
  }

  resetPassword(payload: { email: string; password: string }) {
    return axiosWithoutToken.patch("/auth/reset_password", payload);
  }

  getMe(): Promise<AxiosResponse<ApiResponse<TAppUser>>> {
    return axiosWithoutToken.get<ApiResponse<TAppUser>>("/admin/auth/me");
  }

  login(
    payload: AdminLoginCommand,
  ): Promise<AxiosResponse<AdminLoginResponse>> {
    return axiosWithoutToken.post<AdminLoginResponse>(
      "/admin/auth/login",
      payload,
    );
  }

  mfaAuthenticate(
    payload: AdminMFACommand,
  ): Promise<AxiosResponse<AdminMFAAuthenticateResponse>> {
    return axiosWithoutToken.post<AdminMFAAuthenticateResponse>(
      "/admin/auth/mfa/authenticate",
      payload,
    );
  }

  resendMFA(
    payload: ResendMFACommand,
  ): Promise<AxiosResponse<ResendMFAResponse>> {
    return axiosWithoutToken.post<ResendMFAResponse>(
      "/admin/auth/mfa/resend",
      payload,
    );
  }
}

const AdminAuthService = new AuthenticationService();
export default AdminAuthService;
